import { Badge as MuiBadge, BadgeProps as MuiBadgeProps } from '@mui/material';
import { ReactNode } from 'react';

interface BadgeProps {
  anchorOrigin?: { horizontal: 'left' | 'right'; vertical: 'top' | 'bottom' };
  color: 'error' | 'neutral' | 'success' | 'warning';
  badgeContent?: number;
  margin?: string;
  variant?: 'standard' | 'dot';
  children?: ReactNode;
  inline?: boolean;
}

export const Badge = ({
  anchorOrigin = { horizontal: 'right', vertical: 'top' },
  badgeContent,
  color,
  margin,
  variant = 'standard',
  children,
  inline = false,
}: BadgeProps) => {
  return (
    <MuiBadge
      variant={variant}
      color={color as MuiBadgeProps['color']}
      anchorOrigin={{
        horizontal: anchorOrigin.horizontal,
        vertical: anchorOrigin.vertical,
      }}
      badgeContent={badgeContent}
      sx={{
        margin,
        ...(inline && {
          '& .MuiBadge-badge': {
            position: 'relative',
            transform: 'none',
            margin: 'initial 0',
            padding: 'initial 0',
          },
        }),
      }}
    >
      {children}
    </MuiBadge>
  );
};
